module.exports = __webpack_public_path__ + "static/media/1015329.637f0128.png";